import React from "react";
import clsx from "clsx";
//import CheckCircleIcon from "@material-ui/icons/CheckCircle";
//import ErrorIcon from "@material-ui/icons/Error";
//import InfoIcon from "@material-ui/icons/Info";
//import CloseIcon from "@material-ui/icons/Close";
//import WarningIcon from "@material-ui/icons/Warning";
import { amber, green } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { withStyles } from "@material-ui/core/styles";



const classStyles = theme => ({
  success: {
    backgroundColor: green[600],
    minWidth: '600px'
  },
  error: {
    backgroundColor: theme.palette.error.dark,
    minWidth: '600px',
  },
  info: {
    backgroundColor: theme.palette.primary.main,
    minWidth: '600px',
  },
  warning: {
    backgroundColor: amber[700],
    minWidth: '600px'
  },
  icon: {
    fontSize: 30
  },
  iconVariant: {
    opacity: 1.0,
    marginRight: theme.spacing(1)
  },
  message: {
    display: "flex",
    alignItems: "center",

  }
});

class SnackbarMessageContent extends React.Component{
  
  /*
  getIcon(classes) {
    let messageType = this.props.messageType;
    if(messageType === "success") {
      return <CheckCircleIcon className={clsx(classes.icon, classes.iconVariant)} />;
    }
    else if(messageType === "warning") {
      return <WarningIcon className={clsx(classes.icon, classes.iconVariant)} />;
    }
    else if(messageType === "error") {
      return <ErrorIcon className={clsx(classes.icon, classes.iconVariant)} />;
    }    
    else {
      return <InfoIcon className={clsx(classes.icon, classes.iconVariant)} />;
    } 
  }*/
  

   render(){
     const { classes } = this.props;
      return (
        <SnackbarContent
        className={clsx(classes[this.props.messageType], classes.margin)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>            
            {this.props.message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={() =>this.props.onSnackbarClose()}
          >
            Cerrar
          </IconButton>
        ]}
      />

      );
   }
}

export default withStyles(classStyles)(SnackbarMessageContent);